export function getIsMacPlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }
  // iOS user agents contain "like Mac OS X" (e.g.
  // `iPhone; CPU iPhone OS 17_5 like Mac OS X`), so a loose `/Mac OS X/i`
  // would false-positive on iPhones/iPads. `/Macintosh/i` only appears in
  // real macOS user agents.
  if (/Macintosh/i.test(navigator.userAgent)) {
    // iPadOS 13+ reports `navigator.platform === 'MacIntel'` AND a
    // Macintosh-style userAgent when in desktop mode, so the userAgent
    // alone isn't enough — exclude touch-capable "Macs" which are
    // actually iPads.
    return !(navigator.maxTouchPoints > 1)
  }
  // `navigator.platform` is deprecated but still the most reliable signal
  // on real macOS browsers; values include `MacIntel`, `MacPPC`, `Mac68K`.
  return /^Mac/i.test(navigator.platform) && !(navigator.maxTouchPoints > 1)
}
